import { Component, Inject, Input, OnInit } from '@angular/core';
import {MarketingService} from '../../../../core/services/marketing.service';
import {MatomoService} from '../../../../core/services/matomo.service';
import * as CryptoJS from 'crypto-js';
import { MatomoRequestModel } from '../../../../core/models/matomo.request.model';

@Component({
    selector: 'phx-slider-report',
    templateUrl: './slider-report.component.html',
    styleUrls: ['./slider-report.component.scss',
        '../supplier-report.component.scss'],
    standalone: false
})
export class SliderReportComponent implements OnInit {
  @Input() slide;
  days = 0;
  slides;
  compares;
  click;

  constructor(private marketingService: MarketingService,
              private matomoService: MatomoService,
              @Inject('CDN') public CDN) { }

  ngOnInit(): void {
    this.days = this.matomoService.getDateRange(new Date(this.slide.slide.start), new Date(this.slide.slide.end));

    this.getData();
  }

  getData() {
  const start = this.slide.slide.start.split('T')[0];
  const end = this.slide.slide.end.split('T')[0];

    const slides = new MatomoRequestModel({
      id_site: 3,
      period: 'range',
      date: start + ',' + end,
      label: null,
      secondary_dimension: 'eventCategory',
      segment: 'dimension1%3D%3DApotheken',
      method: 'Events.getAction',
      filter_pattern: this.slide.slide.title + ' - Klick auf Startseite Slider'
    });

    this.matomoService.getAllData([slides]).subscribe(bulk => {
      this.slides = bulk[0];

      this.calculateClickPerformance();

    });

  }

  calculateClickPerformance() {
    if (this.slides.length > 0 && this.compares) {
      const title = this.slide.slide.title.replace('+', ' ').trim();
      const selected = this.slides.find(slide => slide.Events_EventAction.trim() === title);

      const selectedClicks = this.matomoService.calculateClicksPerDay(selected, this.days);

      let compareBulk = [];
      let compareClicks = 0;
      let compareNr = 0;


      for (let compare of this.compares) {
        const compareReq = new MatomoRequestModel({
          id_site: 3,
          period: 'range',
          date: compare.start.split('T')[0] + ',' + compare.end.split('T')[0],
          label: null,
          secondary_dimension: 'eventCategory',
          segment: 'dimension1%3D%3DApotheken',
          method: 'Events.getAction',
          filter_pattern: compare.title + ' - Klick auf Startseite Slider'
        });

        compareBulk.push(compareReq);
      }

      this.matomoService.getAllData(compareBulk).subscribe(bulk=>{
        bulk.forEach((report: any, index: number): void => {
          const selected = this.compares[index];
          let compareDays = 0;
          let title = selected.title.replace('+', ' ').trim();
          compareDays = this.matomoService.getDateRange(new Date(selected.start), new Date(selected.end));

          let comp = report.find(comp => comp.Events_EventAction.trim() === title);

          if (comp) {
            compareClicks += this.matomoService.calculateClicksPerDay(comp, compareDays);
            compareNr++;
          }
        });
        this.click = +((selectedClicks / (compareClicks / compareNr)).toFixed(2));
      });
    }
  }

  getDate(date) {
    return new Date(date);
  }

  getSlideId() {
    const id = CryptoJS.HmacSHA256(this.slide.slide.title + this.slide.slide.start + this.slide.slide.end, 'slide') .toString(CryptoJS.enc.Base64);
    return id;
  }
}
